import styled from "styled-components/macro";

const ModalRoot = styled.div`
  height: 100%;
  width: 100%;
  ${({visible}) => `display: ${visible ? 'flex' : 'none'};`}
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
`;

export default ModalRoot;
